import userDeclarationLocale from './en.json'

const en = {
  userDeclaration: userDeclarationLocale,
}

export default en
